const SUPER_ADMIN = 'super-admin';
const ADMIN = 'admin';

export { SUPER_ADMIN, ADMIN };
